import React from 'react';
import styled from 'styled-components';

import HeroSection from 'components/HeroSection';
import Container from 'components/Container';
import Text from 'components/Text';
import Stack from 'components/Stack';
import TalkToUsCTA from 'components/TalkToUsCTA';

const Section = styled(HeroSection)`
  text-align: center;
`;

const Description = styled(Text)`
  max-width: 50rem;
  margin-top: 1rem;
`;

export default function ToolchainHero() {
  return (
    <Section variant="secondary">
      <Container>
        <Stack gap="2rem" align="center">
          <Text as="span" color="lightTeal" variant="f6">
            Sleuth Integrations
          </Text>
          <div>
            <Text as="h1" variant="hero">
              Keep your toolchain
            </Text>
            <Description variant="p" color="textGray">
              Sleuth leverages all the tools you're already using. No
              rip-and-replace necessary.
            </Description>
          </div>
          <TalkToUsCTA icon="arrow-up-right" />
        </Stack>
      </Container>
    </Section>
  );
}
